import React from 'react'
import styles from './Footer.module.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            Copyright © {currentYear} TREA PTE LTD
        </footer>
    )
}

export default Footer